function cov_1c57z1btyh() {
  var path = "/app/src/types/product-type.ts";
  var hash = "8275f428a3041417bf5699e657a04dca5d174bdb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/types/product-type.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 27
        },
        end: {
          line: 4,
          column: 10
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "8275f428a3041417bf5699e657a04dca5d174bdb"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1c57z1btyh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1c57z1btyh();
export var ProductType = (cov_1c57z1btyh().s[0]++, {
  installments: 'installments',
  default: 'default'
});